
import { UpiPaymentDto } from './upi-payment-dto';
import { PaytmPaymentDto } from './paytm-payment-dto';
import { SwipePayment } from './swipe-payment';
import { GatewayPayment } from './gateway-payment';
import { BankPaymentDto } from './bank-payment-dto';
import { CardPaymentDto } from './card-payment-dto';

export class CollectionDto {

    customerCode: string;
    modeOfPayment: string;
    amount: number;
    locationCode: number;
    bankPaymentDto: BankPaymentDto;
    cardPaymentDto: CardPaymentDto;
    upiPaymentDto: UpiPaymentDto;
    paytmPaymentDto: PaytmPaymentDto;
    swipePaymentDto: SwipePayment;
    gatewayPaymentDto: GatewayPayment;
}
